import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import { bindActionCreators } from "redux";
import { makeStyles, IconButton } from "@material-ui/core";
import { useFormStyles } from "../../workOrderActions/formFields";
import { removeAttachment } from "../../../redux/attachments/attachmentsActions";
import { formatFileOnInput, convertByteArray, isImage } from "../../common/attachments/attachmentsHelper.js";
import { Lightbox } from "../../common/attachments/lightbox";
import DeleteIcon from "../../common/icons/deleteIcon";
import { labourerItemsAreEnabled } from "../../../globals/workOrderStatus";
import FileFilled from "../../../assets/File-filled.svg";

const useStyles = makeStyles((theme) => ({
    attachmentName: {
        paddingBottom: "4px",
        color: "var(--blue-bell)",
        "&:hover": {
            cursor: "pointer",
        },
    },
    description: {
        color: "var(--text-medium)",
    },
    imagePreview: {
        padding: "0px 5px",
    },
    thumbnail: {
        height: "50px",
        width: "50px",
        borderRadius: "4px",
    },
    attachmentCard: {
        display: "flex",
        padding: "5px",
    },
    attachmentClickOpen: {
        display: "flex",
        width: "100%",
    },
    hr: {
        marginRight: "8px",
    },
    attachmentDelete: {
        display: "flex",
    },
}));

export const Attachments = (props) => {
    // Labourers aren't meant to be able to upload (yet- March 30 2021)
    const inputFile = useRef(null);

    const [files, setFiles] = useState([]);
    const [open, setOpen] = useState(false);
    const [fileIndex, setFileIndex] = useState(null);
    const classes = Object.assign(useStyles(), useFormStyles());

    useEffect(() => {
        setFiles(props.workOrderAttachments);
    }, [props.workOrderAttachments]);

    // Labourers aren't meant to be able to upload (yet- March 30 2021)
    /*const handleFileSelection = async (e) => {
        const { files } = e.target;
        if (files && files.length > 0) {
            var formattedFiles = [];
            for (let i = 0; i < files.length; i++) {
                const data = await convertByteArray(files[i]);
                var formattedFile = formatFileOnInput(files[i], data, props.clickDispatchId, props.workOrderNumber);
                formattedFiles.push(formattedFile);
            }
            props.setFilesToUpload([...props.filesToUpload, ...formattedFiles]);
        }
    }*/

    const handleAttachmentSelect = (index) => {
        setFileIndex(index);
        setOpen(true);
    };

    const handleFileDelete = (file) => {
        const fileDetails = {
            id: file.id,
            workOrderNumber: props.workOrderNumber,
            payload: {
                createdDateTime: file.createdDateTime,
                id: file.id,
                newFileDescription: "",
                newFileName: "",
                newFileType: "",
                newRelatedJobId: "",
                newRelatedSourceId: "",
                oldFileDescription: file.fileDescription,
                oldFileName: file.fileName,
                oldFileType: file.fileType,
                oldRelatedJobId: file.relatedJobId,
                oldRelatedSourceId: file.relatedSourceId,
                originatingSystem: "CMIS",
                uploadedBy: props.userProfile.username,
            },
        };
        props.removeAttachment(fileDetails);
    };

    const disabled = !props.workOrderStatus || (props.workOrderStatus.id && labourerItemsAreEnabled(props.workOrderStatus));

    return (
        <div>
            <Lightbox open={open} mobile onClose={() => setOpen(false)} files={files} fileIndex={fileIndex} />
            {
                // Labourers aren't meant to be able to upload (yet- March 30 2021)
                /* <input 
                style={{display: "none"}} 
                multiple
                ref={inputFile}
                onChange={handleFileSelection}
                onClick={(event) => event.target.value = null}
                type="file"
                accept={'image/*'}
            />     */
            }
            {files &&
                files.map((file, i) => (
                    <>
                        <div className={classes.attachmentCard} key={file.id}>
                            <div className={classes.attachmentClickOpen} onClick={() => handleAttachmentSelect(i)}>
                                <div className={classes.imagePreview}>
                                    {isImage(file.extension) ? (
                                        <img className={classes.thumbnail} src={`data:${file.fileType};base64,${file.data}`} />
                                    ) : (
                                        <img className={classes.thumbnail} src={FileFilled} />
                                    )}
                                </div>
                                <div className={classes.formInfo}>
                                    <div className={classes.attachmentName}>
                                        <FormattedMessage
                                            id="tech.wo-details.attachments.filename"
                                            defaultMessage="{name} ({size} bytes)"
                                            description="Tech work order details, file name with size in bytes"
                                            values={{
                                                name: file.fileName,
                                                size: file.size,
                                            }}
                                        />
                                    </div>
                                    <div className={classes.description}>
                                        <FormattedMessage
                                            id="tech.wo-details.attachments.uploadedOn"
                                            defaultMessage="Uploaded on {uploadedOn}"
                                            description="Tech work order details, uploaded on"
                                            values={{
                                                uploadedOn: moment(file.createdDateTime).format("LL H:mm"),
                                            }}
                                        />
                                    </div>
                                    <div className={classes.description}>{file.fileDescription}</div>
                                </div>
                            </div>
                            {!(
                                disabled ||
                                (file.fileName.includes("mapDrawing") && file.fileName.includes(".png")) ||
                                (file.fileName.includes("sketchDrawing") && file.fileName.includes(".png"))
                            ) && (
                                <div className={classes.attachmentDelete}>
                                    <IconButton style={{ padding: "unset" }} onClick={() => handleFileDelete(file)} disabled={disabled}>
                                        <DeleteIcon color={"var(--blue-bell)"} />
                                    </IconButton>
                                </div>
                            )}
                        </div>
                        {i < files.length - 1 && <hr className={classes.hr} />}
                    </>
                ))}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        userProfile: state.login.userProfile,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            removeAttachment,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(Attachments);
